export const locale = {
    lang: 'fr',
    data: {
        BOARD_WHERE_TO_PLACE: 'De quel tableau souhaitez-vous importer les cartes?',
        BOARD_ACTIVITY: 'Tableau',
        CANCEL: 'Annuler',
        SAVE: 'Enregistrer',
    }
};
